module.exports = __webpack_public_path__ + "static/media/light-purple-spot.e3c4c319.png";